import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export type LoadingSkeletonProps = {
  height?: number;
  roundedClassName?: string; // tailwind radius class
};

export function LoadingSkeleton({ height = 520, roundedClassName = 'rounded-xl' }: LoadingSkeletonProps) {
  return (
    <div className="w-full p-4">
      <Skeleton className={`w-full ${roundedClassName}`} style={{ height }} />
    </div>
  );
}

export default LoadingSkeleton;
